import Debug from 'debug';
import { EMPTY_STRING } from '../../utils';
import { dataBroker } from '../../services/DataBroker';

const log = Debug('pdq:flow:tree');
export interface ITreeNode {
  id: string;
  parentId: string;
  title: string;
  items?: ITreeNode[];

  parent?: ITreeNode;
  hierarchy?: string[];
  prev?: ITreeNode;
  next?: ITreeNode;
  selected?: boolean;
}

export class TreeNode implements ITreeNode {
  parent: TreeNode|undefined
  prev: ITreeNode|undefined;
  next: ITreeNode|undefined;
  selected = false
  expanded = true

  isLeaf = () => this.items.length === 0

  constructor(
    public id: string = EMPTY_STRING,
    public parentId: string = EMPTY_STRING,
    public title: string = EMPTY_STRING,
    public items: TreeNode[] = [],
    public hierarchy: string[] = []
    ) {}

}

export class Tree {
  get id() {return this._id}
  multiselect = false
  rootNodes: Set<TreeNode> = new Set<TreeNode>();
  nodes: Set<TreeNode> = new Set<TreeNode>();
  treeMap : Map<string, TreeNode>;
  rootMap : Map<string, TreeNode>;
  selectedNodes: Set<TreeNode> = new Set<TreeNode>();

  constructor(private _id: string, treeNodes: ITreeNode[], multiselect: boolean) {
    this.multiselect = multiselect
    const start = performance.now()
    this.treeMap = new Map(treeNodes
    .filter(i => i && i.id)
    .map((i) => [i.id, new TreeNode(i.id, i.parentId, i.title, [])]));
    this.rootMap = new Map<string, TreeNode>();

    let lastNode:TreeNode|undefined = undefined
    for (const n of this.treeMap.values()) {
      if (lastNode) {
        n.prev = lastNode
        lastNode.next = n
      }

      this.nodes.add(n)
      if (n.parentId) {
        const p = this.treeMap.get(n.parentId)
        if (!p){
          log(`WARNING: tree item ${n.id} has un-resolvable parent ${n.parentId} not found`)
          continue
        }
        n.parent = p
        n.parent.items.push(n)
        let gp = p
        while(gp.parent)
          gp = gp.parent!;
        this.rootMap.set(n.id, gp);
      } else {
        this.rootNodes.add(n)
        this.rootMap.set(n.id, n)
      }
      lastNode = n
    }

    if(lastNode) {
      const firstNode = [...this.treeMap.values()][0]
      firstNode.prev = lastNode
      lastNode.next = firstNode
    }

    for (const n of this.nodes) {
      n.hierarchy = this.getParentHierarchy(n)
    }
    log(`tree construction ran in ${performance.now() - start}ms`);
  }


  toggleSelection(n: TreeNode|undefined) {
    if (!n && !this.nodes.has(n))
      throw new Error(`Failed to toggle selection, node is not a member of this tree!`)

    const node = n!
    node.selected = !node.selected
    if (this.multiselect) {
      if (node.selected) {
        this.selectedNodes.add(node)
      }else{
        this.selectedNodes.delete(node)
      }
    } else {
      if (node.selected) {
        this.selectedNodes.forEach(i => i.selected = false)
        this.selectedNodes.clear()
        this.selectedNodes.add(node)
      }else{
        this.selectedNodes.clear()
      }
    }

    dataBroker.setDataSource(`${this.id}-selected`,
      Array.from(this.selectedNodes).map(i => ({
        // path: i.hierarchy.join('/'),
        // breadcrumbs: i.hierarchy.map(j => this.treeMap.get(j)!.title).join(' > '),

        id: i.id,
        title: i.title,
        isLeaf: i.isLeaf(),
      })))
  }
  toggleExpand(n: TreeNode|undefined) {
    if (!n && !this.nodes.has(n))
      throw new Error(`Failed to toggle expand, node is not a member of this tree!`)

    const node = n!
    node.expanded = !node.expanded
  }

  private getParentHierarchy(node: TreeNode): string[] {
    if (node.hierarchy.length > 0)
      node.hierarchy
    if (!node.parent) {
      return [node.id];
    }
    return [...this.getParentHierarchy(node.parent), node.id];
  }
}